import Api from "../../lib/api";
import { setMessage } from "../shared/notification/slice";

export const getOrganizationAssigneeDetails = async (AssigneeId) => {
    try {
        const response = await Api.get(`organization-assignees/${AssigneeId}?include=branches`);
        return response;
    } catch (error) {
        setMessage({
            content: error,
            title: `Couldn't solve on the Objection `,
            isError: true,
        });
    }
};
